/** GENERATED by libs/shared-ui/src/icons/generate-icons.js — do not edit. Run `npm run generate-icons`. */
import { IconCategoryModel } from '../../lib/components/icon/models/icon-category.model';
import { IconVariantModel } from './icon-variant.model';

export const SOLAR_ICON_NAMES = [
  '4k',
  'accessibility',
  'add-circle',
  'add-folder',
  'add-square',
  'airbuds',
  'airbuds-case',
  'airbuds-case-charge',
  'airbuds-case-minimalistic',
  'airbuds-case-open',
  'airbuds-charge',
  'airbuds-check',
  'airbuds-left',
  'airbuds-remove',
  'airbuds-right',
  'alarm',
  'alarm-add',
  'alarm-pause',
  'alarm-play',
  'alarm-remove',
  'alarm-sleep',
  'alarm-turn-off',
  'album',
  'alt-arrow-down',
  'alt-arrow-down-linear',
  'alt-arrow-left',
  'alt-arrow-left-linear',
  'alt-arrow-right',
  'alt-arrow-right-linear',
  'alt-arrow-up',
  'alt-arrow-up-linear',
  'archive',
  'archive-check',
  'archive-down',
  'archive-down-minimlistic',
  'archive-minimalistic',
  'archive-up',
  'archive-up-minimlistic',
  'armchair',
  'armchair-2',
  'arrow-down',
  'arrow-down-linear',
  'arrow-left',
  'arrow-left-down',
  'arrow-left-down-linear',
  'arrow-left-linear',
  'arrow-left-up',
  'arrow-left-up-linear',
  'arrow-right',
  'arrow-right-down',
  'arrow-right-down-linear',
  'arrow-right-linear',
  'arrow-right-up',
  'arrow-right-up-linear',
  'arrow-to-down-left',
  'arrow-to-down-right',
  'arrow-to-top-left',
  'arrow-to-top-right',
  'arrow-up',
  'arrow-up-linear',
  'augmented-reality',
  'backpack',
  'backspace',
  'balloon',
  'banknote',
  'banknote-2',
  'bar-chair',
  'bath',
  'battery-charge',
  'battery-charge-minimalistic',
  'battery-full',
  'battery-full-minimalistic',
  'battery-half',
  'battery-half-minimalistic',
  'battery-low',
  'battery-low-minimalistic',
  'bed',
  'bedside-table',
  'bedside-table-2',
  'bedside-table-3',
  'bedside-table-4',
  'bell',
  'bell-bing',
  'bell-off',
  'bill',
  'bill-check',
  'bill-cross',
  'bill-list',
  'bluetooth',
  'bluetooth-circle',
  'bluetooth-square',
  'bluetooth-wave',
  'body',
  'bolt',
  'bolt-circle',
  'bomb',
  'bomb-emoji',
  'bomb-minimalistic',
  'book',
  'book-2',
  'book-bookmark',
  'book-bookmark-minimalistic',
  'book-minimalistic',
  'bookmark',
  'bookmark-circle',
  'bookmark-opened',
  'bookmark-square',
  'bookmark-square-minimalistic',
  'boombox',
  'bottle',
  'box',
  'box-minimalistic',
  'branching-paths-down',
  'branching-paths-up',
  'broom',
  'buildings',
  'buildings-2',
  'buildings-3',
  'calculator',
  'calculator-minimalistic',
  'calendar',
  'calendar-add',
  'calendar-date',
  'calendar-linear',
  'calendar-mark',
  'calendar-minimalistic',
  'calendar-search',
  'call-cancel',
  'call-cancel-rounded',
  'call-chat',
  'call-chat-rounded',
  'call-dropped',
  'call-dropped-rounded',
  'call-medicine',
  'call-medicine-rounded',
  'camera',
  'camera-add',
  'camera-minimalistic',
  'camera-rotate',
  'camera-square',
  'card',
  'card-2',
  'card-recive',
  'card-search',
  'card-send',
  'card-transfer',
  'cardholder',
  'case',
  'case-minimalistic',
  'case-round',
  'case-round-minimalistic',
  'cash-out',
  'cassette',
  'cassette-2',
  'cat',
  'chair',
  'chair-2',
  'chandelier',
  'chart',
  'chart-2',
  'chart-square',
  'chat-dots',
  'chat-line',
  'chat-round',
  'chat-round-call',
  'chat-round-check',
  'chat-round-dots',
  'chat-round-like',
  'chat-round-line',
  'chat-round-money',
  'chat-round-unread',
  'chat-round-video',
  'chat-square',
  'chat-square-2',
  'chat-square-arrow',
  'chat-square-call',
  'chat-square-check',
  'chat-square-code',
  'chat-square-like',
  'chat-unread',
  'check-circle',
  'check-read',
  'check-square',
  'checklist',
  'checklist-minimalistic',
  'chef-hat',
  'chef-hat-heart',
  'chef-hat-minimalistic',
  'circle-bottom-down',
  'circle-bottom-up',
  'circle-top-down',
  'circle-top-up',
  'city',
  'clapperboard',
  'clapperboard-edit',
  'clapperboard-open',
  'clapperboard-open-play',
  'clapperboard-play',
  'clapperboard-text',
  'clipboard',
  'clipboard-add',
  'clipboard-check',
  'clipboard-heart',
  'clipboard-list',
  'clipboard-remove',
  'clipboard-text',
  'clock-circle',
  'clock-square',
  'close-circle',
  'close-square',
  'closet',
  'closet-2',
  'cloud',
  'cloud-bolt',
  'cloud-bolt-minimalistic',
  'cloud-check',
  'cloud-cross',
  'cloud-download',
  'cloud-file',
  'cloud-minus',
  'cloud-plus',
  'cloud-rain',
  'cloud-snowfall',
  'cloud-snowfall-minimalistic',
  'cloud-storage',
  'cloud-storm',
  'cloud-sun',
  'cloud-sun-2',
  'cloud-upload',
  'cloud-waterdrop',
  'cloud-waterdrops',
  'clouds',
  'cloudy-moon',
  'code-file',
  'code-scan',
  'compass',
  'compass-big',
  'compass-square',
  'condicioner',
  'condicioner-2',
  'confetti',
  'confetti-minimalistic',
  'copy',
  'copyright',
  'corkscrew',
  'cosmetic',
  'course-down',
  'course-up',
  'cpu',
  'cpu-bolt',
  'creative-commons',
  'crown',
  'crown-line',
  'crown-minimalistic',
  'crown-star',
  'cup',
  'cup-first',
  'cup-hot',
  'cup-music',
  'cup-paper',
  'cup-star',
  'cursor',
  'cursor-square',
  'danger',
  'danger-circle',
  'danger-square',
  'danger-triangle',
  'database',
  'delivery',
  'devices',
  'diagram-down',
  'diagram-up',
  'dialog',
  'dialog-2',
  'diploma',
  'diploma-verified',
  'diskette',
  'dislike',
  'display',
  'document',
  'document-add',
  'document-medicine',
  'document-text',
  'documents',
  'documents-minimalistic',
  'dollar',
  'dollar-minimalistic',
  'donut',
  'donut-bitten',
  'double-alt-arrow-down',
  'double-alt-arrow-down-linear',
  'double-alt-arrow-left',
  'double-alt-arrow-left-linear',
  'double-alt-arrow-right',
  'double-alt-arrow-right-linear',
  'double-alt-arrow-up',
  'double-alt-arrow-up-linear',
  'download',
  'download-minimalistic',
  'download-square',
  'download-twice-square',
  'end-call',
  'end-call-rounded',
  'eraser',
  'eraser-circle',
  'eraser-square',
  'euro',
  'exit',
  'explicit',
  'export',
  'eye',
  'eye-closed',
  'eye-scan',
  'feed',
  'ferris-wheel',
  'figma',
  'figma-file',
  'file',
  'file-check',
  'file-corrupted',
  'file-download',
  'file-favourite',
  'file-left',
  'file-remove',
  'file-right',
  'file-send',
  'file-smile',
  'file-text',
  'filter',
  'filter-linear',
  'flag',
  'flag-2',
  'flash-drive',
  'flashlight',
  'flashlight-on',
  'floor-lamp',
  'floor-lamp-minimalistic',
  'fog',
  'folder',
  'folder-2',
  'folder-check',
  'folder-cloud',
  'folder-error',
  'folder-favourite-bookmark',
  'folder-favourite-star',
  'folder-open',
  'folder-path-connect',
  'folder-security',
  'folder-with-files',
  'forbidden',
  'forbidden-circle',
  'forward',
  'forward-2',
  'fridge',
  'fuel',
  'full-screen',
  'full-screen-circle',
  'full-screen-square',
  'gallery',
  'gallery-add',
  'gallery-check',
  'gallery-circle',
  'gallery-download',
  'gallery-edit',
  'gallery-favourite',
  'gallery-minimalistic',
  'gallery-remove',
  'gallery-round',
  'gallery-send',
  'gallery-wide',
  'gameboy',
  'gamepad',
  'gamepad-charge',
  'gamepad-minimalistic',
  'gamepad-no-charge',
  'gamepad-old',
  'garage',
  'ghost',
  'ghost-smile',
  'gift',
  'glasses',
  'global',
  'globus',
  'gps',
  'graph',
  'graph-down',
  'graph-down-new',
  'graph-new',
  'graph-new-up',
  'graph-up',
  'hamburger-menu',
  'hanger',
  'hanger-2',
  'headphones-round',
  'headphones-round-sound',
  'headphones-square',
  'headphones-square-sound',
  'heart',
  'heart-angle',
  'heart-broken',
  'heart-lock',
  'heart-shine',
  'heart-unlock',
  'hearts',
  'help',
  'high-definition',
  'high-quality',
  'history',
  'history-2',
  'history-3',
  'home',
  'home-2',
  'home-add',
  'home-add-angle',
  'home-angle',
  'home-angle-2',
  'home-smile',
  'home-smile-angle',
  'home-wifi',
  'home-wifi-angle',
  'hospital',
  'hourglass',
  'hourglass-line',
  'import',
  'inbox',
  'inbox-archive',
  'inbox-in',
  'inbox-line',
  'inbox-out',
  'inbox-unread',
  'incognito',
  'incoming-call',
  'incoming-call-rounded',
  'info-circle',
  'info-square',
  'iphone',
  'key',
  'key-minimalistic',
  'key-minimalistic-2',
  'key-minimalistic-square',
  'key-minimalistic-square-2',
  'key-minimalistic-square-3',
  'key-square',
  'key-square-2',
  'keyboard',
  'ladle',
  'lamp',
  'laptop',
  'laptop-2',
  'laptop-3',
  'laptop-minimalistic',
  'letter',
  'letter-opened',
  'letter-unread',
  'library',
  'lightbulb',
  'lightbulb-bolt',
  'lightbulb-minimalistic',
  'lightning',
  'like',
  'link',
  'link-broken',
  'link-broken-minimalistic',
  'link-circle',
  'link-minimalistic',
  'link-minimalistic-2',
  'link-round',
  'link-round-angle',
  'link-square',
  'list',
  'list-arrow-down',
  'list-arrow-down-minimalistic',
  'list-arrow-up',
  'list-arrow-up-minimalistic',
  'list-check',
  'list-check-minimalistic',
  'list-cross',
  'list-cross-minimalistic',
  'list-down',
  'list-down-minimalistic',
  'list-heart',
  'list-heart-minimalistic',
  'list-up',
  'list-up-minimalistic',
  'lock',
  'lock-keyhole',
  'lock-keyhole-minimalistic',
  'lock-keyhole-minimalistic-linear',
  'lock-keyhole-minimalistic-unlocked',
  'lock-keyhole-unlocked',
  'lock-password',
  'lock-password-unlocked',
  'lock-unlocked',
  'login',
  'login-2',
  'login-3',
  'logout',
  'logout-2',
  'logout-3',
  'magic-stick',
  'magic-stick-2',
  'magic-stick-3',
  'magnet',
  'magnet-wave',
  'magnifer',
  'magnifer-bug',
  'magnifer-linear',
  'magnifer-zoom-in',
  'magnifer-zoom-out',
  'mailbox',
  'map',
  'map-arrow-down',
  'map-arrow-left',
  'map-arrow-right',
  'map-arrow-square',
  'map-arrow-up',
  'map-point',
  'map-point-add',
  'map-point-favourite',
  'map-point-hospital',
  'map-point-remove',
  'map-point-rotate',
  'map-point-school',
  'map-point-search',
  'map-point-wave',
  'mask-happly',
  'mask-sad',
  'masks',
  'maximize',
  'maximize-square',
  'maximize-square-2',
  'maximize-square-3',
  'maximize-square-minimalistic',
  'medal-ribbon',
  'medal-ribbon-star',
  'medal-ribbons-star',
  'medal-star',
  'medal-star-circle',
  'medal-star-square',
  'mention-circle',
  'mention-square',
  'menu-dots',
  'menu-dots-circle',
  'menu-dots-square',
  'microphone',
  'microphone-2',
  'microphone-3',
  'microphone-large',
  'minimalistic-magnifer',
  'minimalistic-magnifer-bug',
  'minimalistic-magnifer-zoom-in',
  'minimalistic-magnifer-zoom-out',
  'minimize',
  'minimize-square',
  'minimize-square-2',
  'minimize-square-3',
  'minimize-square-minimalistic',
  'minus-circle',
  'minus-square',
  'mirror',
  'money-bag',
  'monitor',
  'monitor-camera',
  'monitor-smartphone',
  'moon',
  'moon-fog',
  'moon-sleep',
  'moon-stars',
  'mouse',
  'mouse-circle',
  'mouse-minimalistic',
  'move-to-folder',
  'multiple-forward-left',
  'multiple-forward-right',
  'music-library',
  'music-library-2',
  'music-note',
  'music-note-2',
  'music-note-3',
  'music-note-4',
  'music-note-slider',
  'music-note-slider-2',
  'music-notes',
  'muted',
  'notebook',
  'notebook-bookmark',
  'notebook-minimalistic',
  'notebook-square',
  'notes',
  'notes-minimalistic',
  'notification-lines-remove',
  'notification-remove',
  'notification-unread',
  'notification-unread-lines',
  'object-scan',
  'outgoing-call',
  'outgoing-call-rounded',
  'oven-mitts',
  'oven-mitts-minimalistic',
  'panorama',
  'paper-bin',
  'paperclip',
  'paperclip-2',
  'paperclip-rounded',
  'paperclip-rounded-2',
  'paragraph-spacing',
  'passport',
  'passport-minimalistic',
  'password',
  'password-minimalistic',
  'password-minimalistic-input',
  'pause',
  'pause-circle',
  'paw',
  'pen',
  'pen-2',
  'pen-new-round',
  'pen-new-square',
  'people-nearby',
  'perfume',
  'phone',
  'phone-calling',
  'phone-calling-rounded',
  'phone-rounded',
  'pie-chart',
  'pie-chart-2',
  'pie-chart-3',
  'pin',
  'pin-circle',
  'pin-list',
  'pip',
  'pip-2',
  'plaaylist-minimalistic',
  'plain',
  'plain-2',
  'plain-3',
  'plate',
  'play',
  'play-circle',
  'play-stream',
  'playback-speed',
  'playlist',
  'playlist-2',
  'playlist-minimalistic-2',
  'playlist-minimalistic-3',
  'plug-circle',
  'plus-minus',
  'podcast',
  'point-on-map',
  'point-on-map-perspective',
  'posts-carousel-horizontal',
  'posts-carousel-vertical',
  'power',
  'presentation-graph',
  'printer',
  'printer-2',
  'printer-minimalistic',
  'projector',
  'qr-code',
  'question-circle',
  'question-square',
  'quit-full-screen',
  'quit-full-screen-circle',
  'quit-full-screen-square',
  'quit-pip',
  'radar',
  'radar-2',
  'radio',
  'radio-minimalistic',
  'recive-square',
  'recive-twice-square',
  'record',
  'record-circle',
  'record-minimalistic',
  'record-square',
  'reel',
  'reel-2',
  'refresh',
  'refresh-circle',
  'refresh-circle-linear',
  'refresh-linear',
  'refresh-square',
  'refresh-square-linear',
  'remote-controller',
  'remote-controller-2',
  'remote-controller-minimalistic',
  'remove-folder',
  'reorder',
  'repeat',
  'repeat-one',
  'repeat-one-minimalistic',
  'reply',
  'reply-2',
  'restart',
  'restart-circle',
  'restart-circle-linear',
  'restart-linear',
  'restart-square',
  'restart-square-linear',
  'revote',
  'rewind-10-seconds-back',
  'rewind-10-seconds-forward',
  'rewind-15-seconds-back',
  'rewind-15-seconds-forward',
  'rewind-5-seconds-back',
  'rewind-5-seconds-forward',
  'rewind-back',
  'rewind-back-circle',
  'rewind-forward',
  'rewind-forward-circle',
  'rolling-pin',
  'round-alt-arrow-down',
  'round-alt-arrow-down-linear',
  'round-alt-arrow-left',
  'round-alt-arrow-left-linear',
  'round-alt-arrow-right',
  'round-alt-arrow-right-linear',
  'round-alt-arrow-up',
  'round-alt-arrow-up-linear',
  'round-arrow-down',
  'round-arrow-down-linear',
  'round-arrow-left',
  'round-arrow-left-down',
  'round-arrow-left-down-linear',
  'round-arrow-left-linear',
  'round-arrow-left-up',
  'round-arrow-left-up-linear',
  'round-arrow-right',
  'round-arrow-right-down',
  'round-arrow-right-down-linear',
  'round-arrow-right-linear',
  'round-arrow-right-up',
  'round-arrow-right-up-linear',
  'round-arrow-up',
  'round-arrow-up-linear',
  'round-double-alt-arrow-down',
  'round-double-alt-arrow-down-linear',
  'round-double-alt-arrow-left',
  'round-double-alt-arrow-left-linear',
  'round-double-alt-arrow-right',
  'round-double-alt-arrow-right-linear',
  'round-double-alt-arrow-up',
  'round-double-alt-arrow-up-linear',
  'round-graph',
  'round-sort-horizontal',
  'round-sort-horizontal-linear',
  'round-sort-vertical',
  'round-sort-vertical-linear',
  'round-transfer-diagonal',
  'round-transfer-diagonal-linear',
  'round-transfer-horizontal',
  'round-transfer-horizontal-linear',
  'round-transfer-vertical',
  'round-transfer-vertical-linear',
  'rounded-magnifer',
  'rounded-magnifer-bug',
  'rounded-magnifer-zoom-in',
  'rounded-magnifer-zoom-out',
  'route',
  'routing',
  'routing-2',
  'routing-3',
  'ruble',
  'safe-2',
  'safe-circle',
  'safe-square',
  'sale',
  'sale-square',
  'scale',
  'scanner',
  'scanner-2',
  'scissors',
  'scissors-square',
  'screen-share',
  'sd-card',
  'send-square',
  'send-twice-square',
  'server',
  'server-2',
  'server-minimalistic',
  'server-path',
  'server-square',
  'server-square-cloud',
  'server-square-update',
  'settings',
  'settings-minimalistic',
  'share',
  'share-circle',
  'shield',
  'shield-check',
  'shield-cross',
  'shield-keyhole',
  'shield-keyhole-minimalistic',
  'shield-minimalistic',
  'shield-minus',
  'shield-network',
  'shield-plus',
  'shield-star',
  'shield-up',
  'shield-user',
  'shield-warning',
  'shuffle',
  'signpost',
  'signpost-2',
  'sim-card',
  'sim-card-minimalistic',
  'sim-cards',
  'siren',
  'siren-rounded',
  'skip-next',
  'skip-previous',
  'skirt',
  'sledgehammer',
  'sleeping',
  'slider-horizontal',
  'slider-minimalistic-horizontal',
  'slider-vertical',
  'slider-vertical-minimalistic',
  'smart-home',
  'smart-home-angle',
  'smart-speaker',
  'smart-speaker-2',
  'smart-speaker-minimalistic',
  'smart-vacuum-cleaner',
  'smart-vacuum-cleaner-2',
  'smartphone',
  'smartphone-2',
  'smartphone-rotate-2',
  'smartphone-rotate-angle',
  'smartphone-rotate-orientation',
  'smartphone-update',
  'smartphone-vibration',
  'snowflake',
  'socket',
  'sofa',
  'sofa-2',
  'sofa-3',
  'sort',
  'sort-by-alphabet',
  'sort-by-time',
  'sort-from-bottom-to-top',
  'sort-from-top-to-bottom',
  'sort-horizontal',
  'sort-horizontal-linear',
  'sort-vertical',
  'sort-vertical-linear',
  'soundwave',
  'soundwave-circle',
  'soundwave-square',
  'speaker',
  'speaker-minimalistic',
  'special-effects',
  'square-academic-cap',
  'square-academic-cap-2',
  'square-alt-arrow-down',
  'square-alt-arrow-down-linear',
  'square-alt-arrow-left',
  'square-alt-arrow-left-linear',
  'square-alt-arrow-right',
  'square-alt-arrow-right-linear',
  'square-alt-arrow-up',
  'square-alt-arrow-up-linear',
  'square-arrow-down',
  'square-arrow-down-linear',
  'square-arrow-left',
  'square-arrow-left-down',
  'square-arrow-left-down-linear',
  'square-arrow-left-linear',
  'square-arrow-left-up',
  'square-arrow-left-up-linear',
  'square-arrow-right',
  'square-arrow-right-down',
  'square-arrow-right-down-linear',
  'square-arrow-right-linear',
  'square-arrow-right-up',
  'square-arrow-right-up-linear',
  'square-arrow-up',
  'square-arrow-up-linear',
  'square-bottom-down',
  'square-bottom-up',
  'square-double-alt-arrow-down',
  'square-double-alt-arrow-down-linear',
  'square-double-alt-arrow-left',
  'square-double-alt-arrow-left-linear',
  'square-double-alt-arrow-right',
  'square-double-alt-arrow-right-linear',
  'square-double-alt-arrow-up',
  'square-double-alt-arrow-up-linear',
  'square-forward',
  'square-share-line',
  'square-sort-horizontal',
  'square-sort-horizontal-linear',
  'square-sort-vertical',
  'square-sort-vertical-linear',
  'square-top-down',
  'square-top-down-linear',
  'square-top-up',
  'square-transfer-horizontal',
  'square-transfer-horizontal-linear',
  'square-transfer-vertical',
  'square-transfer-vertical-linear',
  'ssd-round',
  'ssd-square',
  'star',
  'star-shine',
  'stars',
  'stop',
  'stop-circle',
  'stopwatch',
  'stopwatch-pause',
  'stopwatch-play',
  'stream',
  'streets',
  'streets-map-point',
  'streets-navigation',
  'subtitles',
  'sun',
  'sun-2',
  'sun-fog',
  'sunrise',
  'sunset',
  't-shirt',
  'tablet',
  'tag',
  'tag-horizontal',
  'tag-price',
  'target',
  'tea-cup',
  'telescope',
  'temperature',
  'text',
  'text-bold',
  'text-bold-circle',
  'text-bold-square',
  'text-circle',
  'text-cross',
  'text-cross-circle',
  'text-cross-square',
  'text-field',
  'text-field-focus',
  'text-italic',
  'text-italic-circle',
  'text-italic-square',
  'text-selection',
  'text-square',
  'text-square-2',
  'text-underline',
  'text-underline-circle',
  'text-underline-cross',
  'ticker-star',
  'ticket',
  'ticket-sale',
  'to-pip',
  'tornado',
  'tornado-small',
  'traffic',
  'traffic-economy',
  'transfer-horizontal',
  'transfer-horizontal-linear',
  'transfer-vertical',
  'transfer-vertical-linear',
  'trash-bin-2',
  'trash-bin-minimalistic',
  'trash-bin-minimalistic-2',
  'trash-bin-trash',
  'trellis',
  'tuning',
  'tuning-2',
  'tuning-3',
  'tuning-4',
  'tuning-square',
  'tuning-square-2',
  'turntable',
  'turntable-minimalistic',
  'turntable-music-note',
  'tv',
  'umbrella',
  'undo-left',
  'undo-left-round',
  'undo-left-round-square',
  'undo-left-square',
  'undo-right',
  'undo-right-round',
  'undo-right-round-square',
  'undo-right-square',
  'unread',
  'upload',
  'upload-minimalistic',
  'upload-square',
  'upload-track',
  'upload-track-2',
  'upload-twice-square',
  'user',
  'user-block',
  'user-block-rounded',
  'user-check',
  'user-check-rounded',
  'user-circle',
  'user-cross',
  'user-cross-rounded',
  'user-hand-up',
  'user-hands',
  'user-heart',
  'user-heart-rounded',
  'user-id',
  'user-minus',
  'user-minus-rounded',
  'user-plus',
  'user-plus-rounded',
  'user-rounded',
  'user-speak',
  'user-speak-rounded',
  'users-group-rounded',
  'users-group-two-rounded',
  'verified-check',
  'video-frame',
  'video-frame-2',
  'video-frame-cut',
  'video-frame-cut-2',
  'video-frame-play-horizontal',
  'video-frame-play-vertical',
  'video-frame-replace',
  'video-library',
  'videocamera',
  'videocamera-add',
  'videocamera-record',
  'vinyl',
  'vinyl-record',
  'volume',
  'volume-cross',
  'volume-knob',
  'volume-loud',
  'volume-small',
  'wad-of-money',
  'wallet',
  'wallet-2',
  'wallet-money',
  'wallpaper',
  'washing-machine',
  'washing-machine-minimalistic',
  'watch-round',
  'watch-square',
  'watch-square-minimalistic',
  'watch-square-minimalistic-charge',
  'waterdrop',
  'waterdrops',
  'weigher',
  'whisk',
  'widget',
  'widget-2',
  'widget-3',
  'widget-4',
  'widget-5',
  'widget-6',
  'widget-add',
  'wind',
  'wineglass',
  'wineglass-triangle',
  'winrar',
  'wireless-charge',
  'xxx',
  'zip-file',
] as const;

export const SOLAR_ICON_NAME_SET: ReadonlySet<string> = new Set(SOLAR_ICON_NAMES);

/** Names whose artwork lives in a non-default sprite; every other name resolves against SOLAR_DEFAULT_VARIANT. */
export const SOLAR_ICON_VARIANT_OVERRIDES: ReadonlyMap<string, IconVariantModel> = new Map([
  ['alt-arrow-down-linear', 'linear'],
  ['alt-arrow-left-linear', 'linear'],
  ['alt-arrow-right-linear', 'linear'],
  ['alt-arrow-up-linear', 'linear'],
  ['arrow-down-linear', 'linear'],
  ['arrow-left-down-linear', 'linear'],
  ['arrow-left-linear', 'linear'],
  ['arrow-left-up-linear', 'linear'],
  ['arrow-right-down-linear', 'linear'],
  ['arrow-right-linear', 'linear'],
  ['arrow-right-up-linear', 'linear'],
  ['arrow-up-linear', 'linear'],
  ['calendar-linear', 'linear'],
  ['double-alt-arrow-down-linear', 'linear'],
  ['double-alt-arrow-left-linear', 'linear'],
  ['double-alt-arrow-right-linear', 'linear'],
  ['double-alt-arrow-up-linear', 'linear'],
  ['filter-linear', 'linear'],
  ['lock-keyhole-minimalistic-linear', 'linear'],
  ['magnifer-linear', 'linear'],
  ['refresh-circle-linear', 'linear'],
  ['refresh-linear', 'linear'],
  ['refresh-square-linear', 'linear'],
  ['restart-circle-linear', 'linear'],
  ['restart-linear', 'linear'],
  ['restart-square-linear', 'linear'],
  ['round-alt-arrow-down-linear', 'linear'],
  ['round-alt-arrow-left-linear', 'linear'],
  ['round-alt-arrow-right-linear', 'linear'],
  ['round-alt-arrow-up-linear', 'linear'],
  ['round-arrow-down-linear', 'linear'],
  ['round-arrow-left-down-linear', 'linear'],
  ['round-arrow-left-linear', 'linear'],
  ['round-arrow-left-up-linear', 'linear'],
  ['round-arrow-right-down-linear', 'linear'],
  ['round-arrow-right-linear', 'linear'],
  ['round-arrow-right-up-linear', 'linear'],
  ['round-arrow-up-linear', 'linear'],
  ['round-double-alt-arrow-down-linear', 'linear'],
  ['round-double-alt-arrow-left-linear', 'linear'],
  ['round-double-alt-arrow-right-linear', 'linear'],
  ['round-double-alt-arrow-up-linear', 'linear'],
  ['round-sort-horizontal-linear', 'linear'],
  ['round-sort-vertical-linear', 'linear'],
  ['round-transfer-diagonal-linear', 'linear'],
  ['round-transfer-horizontal-linear', 'linear'],
  ['round-transfer-vertical-linear', 'linear'],
  ['sort-horizontal-linear', 'linear'],
  ['sort-vertical-linear', 'linear'],
  ['square-alt-arrow-down-linear', 'linear'],
  ['square-alt-arrow-left-linear', 'linear'],
  ['square-alt-arrow-right-linear', 'linear'],
  ['square-alt-arrow-up-linear', 'linear'],
  ['square-arrow-down-linear', 'linear'],
  ['square-arrow-left-down-linear', 'linear'],
  ['square-arrow-left-linear', 'linear'],
  ['square-arrow-left-up-linear', 'linear'],
  ['square-arrow-right-down-linear', 'linear'],
  ['square-arrow-right-linear', 'linear'],
  ['square-arrow-right-up-linear', 'linear'],
  ['square-arrow-up-linear', 'linear'],
  ['square-double-alt-arrow-down-linear', 'linear'],
  ['square-double-alt-arrow-left-linear', 'linear'],
  ['square-double-alt-arrow-right-linear', 'linear'],
  ['square-double-alt-arrow-up-linear', 'linear'],
  ['square-sort-horizontal-linear', 'linear'],
  ['square-sort-vertical-linear', 'linear'],
  ['square-top-down-linear', 'linear'],
  ['square-transfer-horizontal-linear', 'linear'],
  ['square-transfer-vertical-linear', 'linear'],
  ['transfer-horizontal-linear', 'linear'],
  ['transfer-vertical-linear', 'linear'],
]);

export const SOLAR_ICON_CATEGORIES: readonly IconCategoryModel[] = [
  {
    name: 'Arrows',
    icons: [
      'alt-arrow-down',
      'alt-arrow-down-linear',
      'alt-arrow-left',
      'alt-arrow-left-linear',
      'alt-arrow-right',
      'alt-arrow-right-linear',
      'alt-arrow-up',
      'alt-arrow-up-linear',
      'arrow-down',
      'arrow-down-linear',
      'arrow-left',
      'arrow-left-down',
      'arrow-left-down-linear',
      'arrow-left-linear',
      'arrow-left-up',
      'arrow-left-up-linear',
      'arrow-right',
      'arrow-right-down',
      'arrow-right-down-linear',
      'arrow-right-linear',
      'arrow-right-up',
      'arrow-right-up-linear',
      'arrow-up',
      'arrow-up-linear',
      'double-alt-arrow-down',
      'double-alt-arrow-down-linear',
      'double-alt-arrow-left',
      'double-alt-arrow-left-linear',
      'double-alt-arrow-right',
      'double-alt-arrow-right-linear',
      'double-alt-arrow-up',
      'double-alt-arrow-up-linear',
      'refresh',
      'refresh-circle',
      'refresh-circle-linear',
      'refresh-linear',
      'refresh-square',
      'refresh-square-linear',
      'restart',
      'restart-circle',
      'restart-circle-linear',
      'restart-linear',
      'restart-square',
      'restart-square-linear',
      'round-alt-arrow-down',
      'round-alt-arrow-down-linear',
      'round-alt-arrow-left',
      'round-alt-arrow-left-linear',
      'round-alt-arrow-right',
      'round-alt-arrow-right-linear',
      'round-alt-arrow-up',
      'round-alt-arrow-up-linear',
      'round-arrow-down',
      'round-arrow-down-linear',
      'round-arrow-left',
      'round-arrow-left-down',
      'round-arrow-left-down-linear',
      'round-arrow-left-linear',
      'round-arrow-left-up',
      'round-arrow-left-up-linear',
      'round-arrow-right',
      'round-arrow-right-down',
      'round-arrow-right-down-linear',
      'round-arrow-right-linear',
      'round-arrow-right-up',
      'round-arrow-right-up-linear',
      'round-arrow-up',
      'round-arrow-up-linear',
      'round-double-alt-arrow-down',
      'round-double-alt-arrow-down-linear',
      'round-double-alt-arrow-left',
      'round-double-alt-arrow-left-linear',
      'round-double-alt-arrow-right',
      'round-double-alt-arrow-right-linear',
      'round-double-alt-arrow-up',
      'round-double-alt-arrow-up-linear',
      'round-sort-horizontal',
      'round-sort-horizontal-linear',
      'round-sort-vertical',
      'round-sort-vertical-linear',
      'round-transfer-diagonal',
      'round-transfer-diagonal-linear',
      'round-transfer-horizontal',
      'round-transfer-horizontal-linear',
      'round-transfer-vertical',
      'round-transfer-vertical-linear',
      'sort-horizontal',
      'sort-horizontal-linear',
      'sort-vertical',
      'sort-vertical-linear',
      'square-alt-arrow-down',
      'square-alt-arrow-down-linear',
      'square-alt-arrow-left',
      'square-alt-arrow-left-linear',
      'square-alt-arrow-right',
      'square-alt-arrow-right-linear',
      'square-alt-arrow-up',
      'square-alt-arrow-up-linear',
      'square-arrow-down',
      'square-arrow-down-linear',
      'square-arrow-left',
      'square-arrow-left-down',
      'square-arrow-left-down-linear',
      'square-arrow-left-linear',
      'square-arrow-left-up',
      'square-arrow-left-up-linear',
      'square-arrow-right',
      'square-arrow-right-down',
      'square-arrow-right-down-linear',
      'square-arrow-right-linear',
      'square-arrow-right-up',
      'square-arrow-right-up-linear',
      'square-arrow-up',
      'square-arrow-up-linear',
      'square-double-alt-arrow-down',
      'square-double-alt-arrow-down-linear',
      'square-double-alt-arrow-left',
      'square-double-alt-arrow-left-linear',
      'square-double-alt-arrow-right',
      'square-double-alt-arrow-right-linear',
      'square-double-alt-arrow-up',
      'square-double-alt-arrow-up-linear',
      'square-sort-horizontal',
      'square-sort-horizontal-linear',
      'square-sort-vertical',
      'square-sort-vertical-linear',
      'square-transfer-horizontal',
      'square-transfer-horizontal-linear',
      'square-transfer-vertical',
      'square-transfer-vertical-linear',
      'transfer-horizontal',
      'transfer-horizontal-linear',
      'transfer-vertical',
      'transfer-vertical-linear',
    ],
  },
  {
    name: 'Arrows Action',
    icons: [
      'arrow-to-down-left',
      'arrow-to-down-right',
      'arrow-to-top-left',
      'arrow-to-top-right',
      'circle-bottom-down',
      'circle-bottom-up',
      'circle-top-down',
      'circle-top-up',
      'download',
      'download-minimalistic',
      'download-square',
      'download-twice-square',
      'exit',
      'export',
      'forward',
      'forward-2',
      'import',
      'login',
      'login-2',
      'login-3',
      'logout',
      'logout-2',
      'logout-3',
      'maximize',
      'maximize-square',
      'maximize-square-2',
      'maximize-square-3',
      'maximize-square-minimalistic',
      'minimize',
      'minimize-square',
      'minimize-square-2',
      'minimize-square-3',
      'minimize-square-minimalistic',
      'recive-square',
      'recive-twice-square',
      'reorder',
      'reply',
      'reply-2',
      'scale',
      'screen-share',
      'send-square',
      'send-twice-square',
      'square-bottom-down',
      'square-bottom-up',
      'square-top-down',
      'square-top-down-linear',
      'square-top-up',
      'undo-left',
      'undo-left-round',
      'undo-left-round-square',
      'undo-left-square',
      'undo-right',
      'undo-right-round',
      'undo-right-round-square',
      'undo-right-square',
      'upload',
      'upload-minimalistic',
      'upload-square',
      'upload-twice-square',
    ],
  },
  { name: 'Building, Infrastructure', icons: ['buildings', 'buildings-2', 'buildings-3', 'city', 'garage', 'home', 'hospital'] },
  {
    name: 'Business, Statistic',
    icons: [
      'chart',
      'chart-2',
      'chart-square',
      'chat-square-2',
      'course-down',
      'course-up',
      'diagram-down',
      'diagram-up',
      'graph',
      'graph-down',
      'graph-down-new',
      'graph-new',
      'graph-new-up',
      'graph-up',
      'pie-chart',
      'pie-chart-2',
      'pie-chart-3',
      'presentation-graph',
      'round-graph',
    ],
  },
  {
    name: 'Call',
    icons: [
      'call-cancel',
      'call-cancel-rounded',
      'call-chat',
      'call-chat-rounded',
      'call-dropped',
      'call-dropped-rounded',
      'call-medicine',
      'call-medicine-rounded',
      'end-call',
      'end-call-rounded',
      'incoming-call',
      'incoming-call-rounded',
      'outgoing-call',
      'outgoing-call-rounded',
      'phone',
      'phone-calling',
      'phone-calling-rounded',
      'phone-rounded',
      'record-circle',
      'record-minimalistic',
      'record-square',
    ],
  },
  {
    name: 'Electronic, Devices',
    icons: [
      'airbuds',
      'airbuds-case',
      'airbuds-case-charge',
      'airbuds-case-minimalistic',
      'airbuds-case-open',
      'airbuds-charge',
      'airbuds-check',
      'airbuds-left',
      'airbuds-remove',
      'airbuds-right',
      'bluetooth',
      'bluetooth-circle',
      'bluetooth-square',
      'bluetooth-wave',
      'boombox',
      'cassette',
      'cassette-2',
      'cloud-storage',
      'cpu',
      'cpu-bolt',
      'devices',
      'diskette',
      'display',
      'flash-drive',
      'gameboy',
      'gamepad',
      'gamepad-charge',
      'gamepad-minimalistic',
      'gamepad-no-charge',
      'gamepad-old',
      'headphones-round',
      'headphones-round-sound',
      'headphones-square',
      'headphones-square-sound',
      'iphone',
      'keyboard',
      'laptop',
      'laptop-2',
      'laptop-3',
      'laptop-minimalistic',
      'lightbulb',
      'lightbulb-bolt',
      'lightbulb-minimalistic',
      'lightning',
      'monitor',
      'monitor-camera',
      'monitor-smartphone',
      'mouse',
      'mouse-circle',
      'mouse-minimalistic',
      'plug-circle',
      'printer',
      'printer-2',
      'printer-minimalistic',
      'projector',
      'radio',
      'radio-minimalistic',
      'sd-card',
      'server',
      'server-2',
      'server-minimalistic',
      'server-path',
      'server-square',
      'server-square-cloud',
      'server-square-update',
      'sim-card',
      'sim-card-minimalistic',
      'sim-cards',
      'smart-speaker',
      'smart-speaker-2',
      'smart-speaker-minimalistic',
      'smartphone',
      'smartphone-2',
      'smartphone-rotate-2',
      'smartphone-rotate-angle',
      'smartphone-rotate-orientation',
      'smartphone-update',
      'smartphone-vibration',
      'socket',
      'ssd-round',
      'ssd-square',
      'tablet',
      'telescope',
      'turntable',
      'turntable-minimalistic',
      'turntable-music-note',
      'tv',
      'weigher',
      'wireless-charge',
    ],
  },
  {
    name: 'Essentional, UI',
    icons: [
      '4k',
      'accessibility',
      'add-circle',
      'add-square',
      'augmented-reality',
      'balloon',
      'battery-charge',
      'battery-charge-minimalistic',
      'battery-full',
      'battery-full-minimalistic',
      'battery-half',
      'battery-half-minimalistic',
      'battery-low',
      'battery-low-minimalistic',
      'body',
      'bolt',
      'bolt-circle',
      'box',
      'box-minimalistic',
      'broom',
      'cat',
      'check-circle',
      'check-square',
      'close-circle',
      'close-square',
      'confetti',
      'confetti-minimalistic',
      'copy',
      'copyright',
      'cosmetic',
      'creative-commons',
      'crown',
      'crown-line',
      'crown-minimalistic',
      'crown-star',
      'cup',
      'cup-first',
      'cup-music',
      'cup-star',
      'cursor',
      'cursor-square',
      'danger',
      'danger-circle',
      'danger-square',
      'danger-triangle',
      'database',
      'delivery',
      'explicit',
      'feed',
      'ferris-wheel',
      'figma',
      'filter',
      'filter-linear',
      'flag',
      'flag-2',
      'flashlight',
      'flashlight-on',
      'forbidden',
      'forbidden-circle',
      'fuel',
      'ghost',
      'ghost-smile',
      'gift',
      'glasses',
      'hamburger-menu',
      'hanger',
      'hanger-2',
      'help',
      'high-definition',
      'high-quality',
      'home-2',
      'home-add',
      'home-add-angle',
      'home-angle',
      'home-angle-2',
      'home-smile',
      'home-smile-angle',
      'home-wifi',
      'home-wifi-angle',
      'info-circle',
      'info-square',
      'magic-stick',
      'magic-stick-2',
      'magic-stick-3',
      'magnet',
      'magnet-wave',
      'mask-happly',
      'mask-sad',
      'masks',
      'mention-circle',
      'mention-square',
      'menu-dots',
      'menu-dots-circle',
      'menu-dots-square',
      'minus-circle',
      'minus-square',
      'mirror',
      'paper-bin',
      'paw',
      'perfume',
      'pin',
      'pin-circle',
      'pin-list',
      'plate',
      'posts-carousel-horizontal',
      'posts-carousel-vertical',
      'power',
      'question-circle',
      'question-square',
      'revote',
      'scissors',
      'scissors-square',
      'share',
      'share-circle',
      'skirt',
      'sledgehammer',
      'sleeping',
      'slider-horizontal',
      'slider-minimalistic-horizontal',
      'slider-vertical',
      'slider-vertical-minimalistic',
      'smart-home',
      'smart-home-angle',
      'sort',
      'special-effects',
      'subtitles',
      't-shirt',
      'target',
      'traffic',
      'traffic-economy',
      'trash-bin-2',
      'trash-bin-minimalistic',
      'trash-bin-minimalistic-2',
      'trash-bin-trash',
      'umbrella',
      'waterdrop',
      'winrar',
      'xxx',
    ],
  },
  {
    name: 'Files',
    icons: [
      'cloud-file',
      'code-file',
      'figma-file',
      'file',
      'file-check',
      'file-corrupted',
      'file-download',
      'file-favourite',
      'file-left',
      'file-remove',
      'file-right',
      'file-send',
      'file-smile',
      'file-text',
      'zip-file',
    ],
  },
  {
    name: 'Folders',
    icons: [
      'add-folder',
      'folder',
      'folder-2',
      'folder-check',
      'folder-cloud',
      'folder-error',
      'folder-favourite-bookmark',
      'folder-favourite-star',
      'folder-open',
      'folder-path-connect',
      'folder-security',
      'folder-with-files',
      'move-to-folder',
      'remove-folder',
    ],
  },
  {
    name: 'Food, Kitchen',
    icons: [
      'bottle',
      'chef-hat',
      'chef-hat-heart',
      'chef-hat-minimalistic',
      'corkscrew',
      'cup-hot',
      'cup-paper',
      'donut',
      'donut-bitten',
      'ladle',
      'oven-mitts',
      'oven-mitts-minimalistic',
      'rolling-pin',
      'tea-cup',
      'whisk',
      'wineglass',
      'wineglass-triangle',
    ],
  },
  {
    name: 'Home, Furniture',
    icons: [
      'armchair',
      'armchair-2',
      'bar-chair',
      'bath',
      'bed',
      'bedside-table',
      'bedside-table-2',
      'bedside-table-3',
      'bedside-table-4',
      'chair',
      'chair-2',
      'chandelier',
      'closet',
      'closet-2',
      'condicioner',
      'condicioner-2',
      'floor-lamp',
      'floor-lamp-minimalistic',
      'fridge',
      'lamp',
      'remote-controller',
      'remote-controller-2',
      'remote-controller-minimalistic',
      'smart-vacuum-cleaner',
      'smart-vacuum-cleaner-2',
      'sofa',
      'sofa-2',
      'sofa-3',
      'speaker',
      'speaker-minimalistic',
      'trellis',
      'volume-knob',
      'washing-machine',
      'washing-machine-minimalistic',
    ],
  },
  {
    name: 'Like',
    icons: [
      'dislike',
      'heart',
      'heart-angle',
      'heart-broken',
      'heart-lock',
      'heart-shine',
      'heart-unlock',
      'hearts',
      'like',
      'medal-ribbon',
      'medal-ribbon-star',
      'medal-ribbons-star',
      'medal-star',
      'medal-star-circle',
      'medal-star-square',
      'star',
      'star-shine',
    ],
  },
  {
    name: 'List',
    icons: [
      'bill',
      'checklist',
      'checklist-minimalistic',
      'list',
      'list-arrow-down',
      'list-arrow-down-minimalistic',
      'list-arrow-up',
      'list-arrow-up-minimalistic',
      'list-check',
      'list-check-minimalistic',
      'list-cross',
      'list-cross-minimalistic',
      'list-down',
      'list-down-minimalistic',
      'list-heart',
      'list-heart-minimalistic',
      'list-up',
      'list-up-minimalistic',
      'plaaylist-minimalistic',
      'playlist',
      'playlist-2',
      'playlist-minimalistic-2',
      'playlist-minimalistic-3',
      'sort-by-alphabet',
      'sort-by-time',
      'sort-from-bottom-to-top',
      'sort-from-top-to-bottom',
    ],
  },
  {
    name: 'Map & Location',
    icons: [
      'branching-paths-down',
      'branching-paths-up',
      'compass',
      'compass-big',
      'compass-square',
      'global',
      'globus',
      'gps',
      'map',
      'map-arrow-down',
      'map-arrow-left',
      'map-arrow-right',
      'map-arrow-square',
      'map-arrow-up',
      'map-point',
      'map-point-add',
      'map-point-favourite',
      'map-point-hospital',
      'map-point-remove',
      'map-point-rotate',
      'map-point-school',
      'map-point-search',
      'map-point-wave',
      'people-nearby',
      'point-on-map',
      'point-on-map-perspective',
      'radar',
      'radar-2',
      'route',
      'routing',
      'routing-2',
      'routing-3',
      'signpost',
      'signpost-2',
      'streets',
      'streets-map-point',
      'streets-navigation',
    ],
  },
  {
    name: 'Messages, Conversation',
    icons: [
      'chat-dots',
      'chat-line',
      'chat-round',
      'chat-round-call',
      'chat-round-check',
      'chat-round-dots',
      'chat-round-like',
      'chat-round-line',
      'chat-round-money',
      'chat-round-unread',
      'chat-round-video',
      'chat-square',
      'chat-square-arrow',
      'chat-square-call',
      'chat-square-check',
      'chat-square-code',
      'chat-square-like',
      'chat-unread',
      'check-read',
      'dialog',
      'dialog-2',
      'inbox',
      'inbox-archive',
      'inbox-in',
      'inbox-line',
      'inbox-out',
      'inbox-unread',
      'letter',
      'letter-opened',
      'letter-unread',
      'mailbox',
      'multiple-forward-left',
      'multiple-forward-right',
      'paperclip',
      'paperclip-2',
      'paperclip-rounded',
      'paperclip-rounded-2',
      'pen',
      'pen-2',
      'pen-new-round',
      'pen-new-square',
      'plain',
      'plain-2',
      'plain-3',
      'square-forward',
      'square-share-line',
      'unread',
    ],
  },
  {
    name: 'Money',
    icons: [
      'banknote',
      'banknote-2',
      'bill-check',
      'bill-cross',
      'bill-list',
      'card',
      'card-2',
      'card-recive',
      'card-search',
      'card-send',
      'card-transfer',
      'cardholder',
      'cash-out',
      'dollar',
      'dollar-minimalistic',
      'euro',
      'money-bag',
      'ruble',
      'safe-2',
      'safe-circle',
      'safe-square',
      'sale',
      'sale-square',
      'tag',
      'tag-horizontal',
      'tag-price',
      'ticker-star',
      'ticket',
      'ticket-sale',
      'verified-check',
      'wad-of-money',
      'wallet',
      'wallet-2',
      'wallet-money',
    ],
  },
  {
    name: 'Notes',
    icons: [
      'archive',
      'archive-check',
      'archive-down',
      'archive-down-minimlistic',
      'archive-minimalistic',
      'archive-up',
      'archive-up-minimlistic',
      'clipboard',
      'clipboard-add',
      'clipboard-check',
      'clipboard-heart',
      'clipboard-list',
      'clipboard-remove',
      'clipboard-text',
      'document',
      'document-add',
      'document-medicine',
      'document-text',
      'documents',
      'documents-minimalistic',
      'notebook',
      'notes',
      'notes-minimalistic',
    ],
  },
  {
    name: 'Notifications',
    icons: [
      'bell',
      'bell-bing',
      'bell-off',
      'notification-lines-remove',
      'notification-remove',
      'notification-unread',
      'notification-unread-lines',
    ],
  },
  {
    name: 'School',
    icons: [
      'backpack',
      'book',
      'book-2',
      'book-bookmark',
      'book-bookmark-minimalistic',
      'book-minimalistic',
      'bookmark',
      'bookmark-circle',
      'bookmark-opened',
      'bookmark-square',
      'bookmark-square-minimalistic',
      'calculator',
      'calculator-minimalistic',
      'case',
      'case-minimalistic',
      'case-round',
      'case-round-minimalistic',
      'diploma',
      'diploma-verified',
      'notebook-bookmark',
      'notebook-minimalistic',
      'notebook-square',
      'passport',
      'passport-minimalistic',
      'plus-minus',
      'square-academic-cap',
      'square-academic-cap-2',
    ],
  },
  {
    name: 'Search',
    icons: [
      'magnifer',
      'magnifer-bug',
      'magnifer-linear',
      'magnifer-zoom-in',
      'magnifer-zoom-out',
      'minimalistic-magnifer',
      'minimalistic-magnifer-bug',
      'minimalistic-magnifer-zoom-in',
      'minimalistic-magnifer-zoom-out',
      'rounded-magnifer',
      'rounded-magnifer-bug',
      'rounded-magnifer-zoom-in',
      'rounded-magnifer-zoom-out',
    ],
  },
  {
    name: 'Security',
    icons: [
      'bomb',
      'bomb-emoji',
      'bomb-minimalistic',
      'code-scan',
      'eye',
      'eye-closed',
      'eye-scan',
      'incognito',
      'key',
      'key-minimalistic',
      'key-minimalistic-2',
      'key-minimalistic-square',
      'key-minimalistic-square-2',
      'key-minimalistic-square-3',
      'key-square',
      'key-square-2',
      'lock',
      'lock-keyhole',
      'lock-keyhole-minimalistic',
      'lock-keyhole-minimalistic-linear',
      'lock-keyhole-minimalistic-unlocked',
      'lock-keyhole-unlocked',
      'lock-password',
      'lock-password-unlocked',
      'lock-unlocked',
      'object-scan',
      'password',
      'password-minimalistic',
      'password-minimalistic-input',
      'qr-code',
      'scanner',
      'scanner-2',
      'shield',
      'shield-check',
      'shield-cross',
      'shield-keyhole',
      'shield-keyhole-minimalistic',
      'shield-minimalistic',
      'shield-minus',
      'shield-network',
      'shield-plus',
      'shield-star',
      'shield-up',
      'shield-user',
      'shield-warning',
      'siren',
      'siren-rounded',
    ],
  },
  {
    name: 'Settings, Fine Tuning',
    icons: [
      'settings',
      'settings-minimalistic',
      'tuning',
      'tuning-2',
      'tuning-3',
      'tuning-4',
      'tuning-square',
      'tuning-square-2',
      'widget',
      'widget-2',
      'widget-3',
      'widget-4',
      'widget-5',
      'widget-6',
      'widget-add',
    ],
  },
  {
    name: 'Text Formatting',
    icons: [
      'backspace',
      'eraser',
      'eraser-circle',
      'eraser-square',
      'link',
      'link-broken',
      'link-broken-minimalistic',
      'link-circle',
      'link-minimalistic',
      'link-minimalistic-2',
      'link-round',
      'link-round-angle',
      'link-square',
      'paragraph-spacing',
      'text',
      'text-bold',
      'text-bold-circle',
      'text-bold-square',
      'text-circle',
      'text-cross',
      'text-cross-circle',
      'text-cross-square',
      'text-field',
      'text-field-focus',
      'text-italic',
      'text-italic-circle',
      'text-italic-square',
      'text-selection',
      'text-square',
      'text-square-2',
      'text-underline',
      'text-underline-circle',
      'text-underline-cross',
    ],
  },
  {
    name: 'Time',
    icons: [
      'alarm',
      'alarm-add',
      'alarm-pause',
      'alarm-play',
      'alarm-remove',
      'alarm-sleep',
      'alarm-turn-off',
      'calendar',
      'calendar-add',
      'calendar-date',
      'calendar-linear',
      'calendar-mark',
      'calendar-minimalistic',
      'calendar-search',
      'clock-circle',
      'clock-square',
      'history',
      'history-2',
      'history-3',
      'hourglass',
      'hourglass-line',
      'stopwatch',
      'stopwatch-pause',
      'stopwatch-play',
      'watch-round',
      'watch-square',
      'watch-square-minimalistic',
      'watch-square-minimalistic-charge',
    ],
  },
  {
    name: 'Users',
    icons: [
      'user',
      'user-block',
      'user-block-rounded',
      'user-check',
      'user-check-rounded',
      'user-circle',
      'user-cross',
      'user-cross-rounded',
      'user-hand-up',
      'user-hands',
      'user-heart',
      'user-heart-rounded',
      'user-id',
      'user-minus',
      'user-minus-rounded',
      'user-plus',
      'user-plus-rounded',
      'user-rounded',
      'user-speak',
      'user-speak-rounded',
      'users-group-rounded',
      'users-group-two-rounded',
    ],
  },
  {
    name: 'Video, Audio, Sound',
    icons: [
      'album',
      'camera',
      'camera-add',
      'camera-minimalistic',
      'camera-rotate',
      'camera-square',
      'clapperboard',
      'clapperboard-edit',
      'clapperboard-open',
      'clapperboard-open-play',
      'clapperboard-play',
      'clapperboard-text',
      'full-screen',
      'full-screen-circle',
      'full-screen-square',
      'gallery',
      'gallery-add',
      'gallery-check',
      'gallery-circle',
      'gallery-download',
      'gallery-edit',
      'gallery-favourite',
      'gallery-minimalistic',
      'gallery-remove',
      'gallery-round',
      'gallery-send',
      'gallery-wide',
      'library',
      'microphone',
      'microphone-2',
      'microphone-3',
      'microphone-large',
      'music-library',
      'music-library-2',
      'music-note',
      'music-note-2',
      'music-note-3',
      'music-note-4',
      'music-note-slider',
      'music-note-slider-2',
      'music-notes',
      'muted',
      'panorama',
      'pause',
      'pause-circle',
      'pip',
      'pip-2',
      'play',
      'play-circle',
      'play-stream',
      'playback-speed',
      'podcast',
      'quit-full-screen',
      'quit-full-screen-circle',
      'quit-full-screen-square',
      'quit-pip',
      'record',
      'reel',
      'reel-2',
      'repeat',
      'repeat-one',
      'repeat-one-minimalistic',
      'rewind-10-seconds-back',
      'rewind-10-seconds-forward',
      'rewind-15-seconds-back',
      'rewind-15-seconds-forward',
      'rewind-5-seconds-back',
      'rewind-5-seconds-forward',
      'rewind-back',
      'rewind-back-circle',
      'rewind-forward',
      'rewind-forward-circle',
      'shuffle',
      'skip-next',
      'skip-previous',
      'soundwave',
      'soundwave-circle',
      'soundwave-square',
      'stop',
      'stop-circle',
      'stream',
      'to-pip',
      'upload-track',
      'upload-track-2',
      'video-frame',
      'video-frame-2',
      'video-frame-cut',
      'video-frame-cut-2',
      'video-frame-play-horizontal',
      'video-frame-play-vertical',
      'video-frame-replace',
      'video-library',
      'videocamera',
      'videocamera-add',
      'videocamera-record',
      'vinyl',
      'vinyl-record',
      'volume',
      'volume-cross',
      'volume-loud',
      'volume-small',
      'wallpaper',
    ],
  },
  {
    name: 'Weather',
    icons: [
      'cloud',
      'cloud-bolt',
      'cloud-bolt-minimalistic',
      'cloud-check',
      'cloud-cross',
      'cloud-download',
      'cloud-minus',
      'cloud-plus',
      'cloud-rain',
      'cloud-snowfall',
      'cloud-snowfall-minimalistic',
      'cloud-storm',
      'cloud-sun',
      'cloud-sun-2',
      'cloud-upload',
      'cloud-waterdrop',
      'cloud-waterdrops',
      'clouds',
      'cloudy-moon',
      'fog',
      'moon',
      'moon-fog',
      'moon-sleep',
      'moon-stars',
      'snowflake',
      'stars',
      'sun',
      'sun-2',
      'sun-fog',
      'sunrise',
      'sunset',
      'temperature',
      'tornado',
      'tornado-small',
      'waterdrops',
      'wind',
    ],
  },
];

export const SOLAR_SPRITE_VERSION = 'e5fb85f0d4';
export const SOLAR_SPRITE_BASE_PATH = 'assets/shared-ui/icons';
export const SOLAR_DEFAULT_VARIANT: IconVariantModel = 'bold';
